import app from 'flarum/forum/app';
import Model from 'flarum/common/Model';
import Group from 'flarum/common/models/Group';
import Forum from 'flarum/common/models/Forum';
import User from 'flarum/common/models/User';

import UserSubscriptionsPage from './Pages/UserSubscriptionsPage';
import AccessPortal from './Pages/AccessPortal';

import PtbDiscussionBumped from './Post/PtbDiscussionBumped';
import PtvRequiresPayment from './Post/PtvRequiresPayment';

import Discussion from './../common/Discussion';
import Tag from './../common/Tag';
import Subscription from './../common/Subscription';

import PayToBump from './Discussion/PayToBump';
import PayToPost from './Discussion/PayToPost';
import Bounty from './Discussion/Bounty';
import PayToView from './Discussion/PayToView';

import AddNavItem from './addNavItem';

app.initializers.add('blomstra-payments', () => {
  app.store.models.blomstra_subscription = Subscription;

  Discussion();
  Tag();

  Forum.prototype.pk = Model.attribute<string>('blomstra-payments.stripe-pk');
  Forum.prototype.blomstraLinkAccessPortal = Model.attribute<string>('blomstra-payments.link-access-portal');

  Group.prototype.blomstraPtaProduct = Model.attribute<string>('blomstra.pta.product');

  User.prototype.stripeId = Model.attribute<string>('stripeId');

  app.postComponents.ptbDiscussionBumped = PtbDiscussionBumped;
  app.postComponents.ptvRequiresPayment = PtvRequiresPayment;

  app.routes['blomstra-payments.access-portal'] = { path: '/access-portal', component: AccessPortal };
  app.routes['blomstra-payments.user-payments'] = {
    path: '/u/:username/blomstra-payments',
    component: UserSubscriptionsPage,
  };

  PayToBump();
  PayToPost();
  Bounty();
  PayToView();
  AddNavItem();
});
